"use strict";

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var app = require('app');

module.exports = function (_ref) {
  var el = _ref.el;
  el.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // Read raw href; `e.currentTarget.href` drops the subfolder prefix.

    var rawHref = e.currentTarget.getAttribute('href');
    var url = rawHref && (0, _absoluteUrlRuntime.resolveUrl)(rawHref) || e.currentTarget.href;
    var xhr = new window.XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 2) {
        if (xhr.status === 200) {
          return window.open(url);
        } else {
          app.events.commands.execute('modal:attachments-pending-modal:show');
        }
      }
    };

    xhr.open('GET', url);
    xhr.send();
  });
};